import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { DndContext } from '@dnd-kit/core';
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
import { SEGMENT_ITEM_WIDTH } from '../../../../PipelineConfigJsField.constants';
import { SegmentItem } from './components';
export const DragSegments = ({ fieldConfig, fieldValues, isReadOnly, onValueChange, onDragEnd, onDelete }) => {
    const container = useRef(null);
    const prevAmount = useRef(0);
    useEffect(() => {
        if (container.current) {
            const amount = Object.keys(fieldValues.segments).length;
            if (prevAmount.current > 0 && amount > prevAmount.current) {
                container.current.scrollTo({
                    left: container.current.scrollWidth,
                    behavior: 'smooth'
                });
            }
            prevAmount.current = amount;
        }
    }, [fieldValues.segments]);
    return (_jsx(Box, { ref: container, overflowX: 'auto', whiteSpace: 'nowrap', children: _jsx(Flex, { p: "0 2px", w: `${SEGMENT_ITEM_WIDTH * Object.keys(fieldValues.segments).length}px`, children: _jsx(DndContext, { modifiers: [restrictToHorizontalAxis], onDragEnd: onDragEnd, children: _jsx(SortableContext, { disabled: isReadOnly, items: fieldValues.segmentsOrder, children: fieldValues.segmentsOrder.map((uuid) => (_jsx(SegmentItem, { uuid: uuid, segment: fieldValues.segments[uuid], fieldConfig: fieldConfig, isReadOnly: isReadOnly, onValueChange: onValueChange, onDelete: onDelete }, uuid))) }) }) }) }));
};
//# sourceMappingURL=DragSegments.js.map